import * as React from 'react';
import { IEpiProps } from '../../state-helpers/epi-props';
import { ISearchResult } from '../../state-helpers/search-results';
import { Lock } from './lock';
import { DomainLogo } from './domain-logo';
import { MediaIcon } from './media-icon';
import { showIssueNumber, showPublicationName, showPublishDate, showSections, showShortDescription, showVolumeNumber, showArticleImage, showArticleUrl  } from './shared/results-helpers';
import { SearchResultLabels } from './shared/search-result-labels';

interface IProps {
    result: ISearchResult;
    epiProps: IEpiProps;

    onClick: () => void;
}

interface IState {

}

export class SearchResultGeneral extends React.Component<IProps, IState>{
    GetBookSectionText() {
        let result = this.props.result;
        let text = "";
        if (result.bookSections != null && result.bookSections.length > 0) {
            for (let i = 0; i < result.bookSections.length; i++) {
                text = text + " > " + result.bookSections[i];
            }
        }

        if (result.pageNumbers != null && result.pageNumbers.length > 0)
            text = text + " > " + result.pageNumbers;

        return text;
    }

    render() {
        let { result, epiProps } = this.props
        return (
            <div className="search-result-wrapper">

                <a className="search-result search-result-all-aap" href={ result.url } onClick={this.props.onClick}>

                    {(showArticleImage(result)) &&
                        <div className="search-result-image">
                            <img src={`${result.automaticLandingPageImage}?width=400`} />
                        </div>
                    }
                    <div className="search-resut-info">
                        <div className="search-result-header">

                            <div className="search-result-title" dangerouslySetInnerHTML={{ __html: result.title }} />
                            <DomainLogo url={result.friendlyUrl} />
                        </div>

                        {(showPublicationName(result) || showVolumeNumber(result) || showIssueNumber(result) || showSections(result)) &&
                            <div className="search-result-meta">
                            {(showPublicationName) && <span className="search-result-meta-publication">{result.publicationName} {(showSections(result)) && this.GetBookSectionText()} </span>}

                            {(showPublicationName && showVolumeNumber(result)) && <span className="middle-dot">&middot;</span>}

                            {(showVolumeNumber(result)) && <span className="search-result-meta-volume">Volume {result.volumeNumber}</span>}

                            {(showVolumeNumber(result) && showIssueNumber(result)) && <span className="middle-dot">&middot;</span>}

                            {(showIssueNumber(result)) && <span className="search-result-meta-number">Number {result.issueNumber}</span>}
                            </div>
                        }
                        {(showPublishDate(result) || showShortDescription(result)) &&
                            <div className="search-result-excerpt">
                                {showPublishDate(result) &&
                                <div>
                                    <span>
                                        <span className="search-result-excerpt-date">{result.publishDate.toString()}</span>
                                    </span>
                                </div>
                            }
                            { showShortDescription(result) &&
                                    < span className="search-result-content" dangerouslySetInnerHTML={{ __html: result.shortDescription }}></span>
                                }
                            </div>
                        }

                        <SearchResultLabels
                            result={result}
                            epiProps={epiProps}
                        />

                        { showArticleUrl() &&
                            <div className="search-result-link">
                                {this.props.result.iconType &&
                                    <MediaIcon type={this.props.result.iconType} />
                                }
                                <Lock url={this.props.result.url} />
                                <u>{this.props.result.friendlyUrl}</u>
                            </div>
                        }
                    </div>
                </a>
            </div>
        )
    }
}
